import React, { useContext, useState } from "react";
import { Form as FinalForm, Field } from "react-final-form";
import { Container, Form, Button, Label } from "semantic-ui-react";
import {
  combineValidators,
  composeValidators,
  isRequired,
  hasLengthGreaterThan,
  hasLengthLessThan,
  matchesPattern,
} from "revalidate";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../../app/stores/rootStore";
import { IUserAdmin } from "../../../app/models/user";
import TextInput from "../../../app/common/form/TextInput";

const validate = combineValidators({
  "user.username": composeValidators(
    matchesPattern(/^[a-zA-Z0-9\.\-_@]*$/)({
      message:
        "Usuario de acceso  no válido. Contiene espacios o caracteres especiales diferente a: - . _ @",
    }),
    isRequired({ message: "El Usuario es obligatorio" }),
    hasLengthGreaterThan(5)({
      message: "El Usuario de acceso debe tener al menos 6 caracteres",
    }),
    hasLengthLessThan(129)({
      message: "El Usuario de acceso debe tener máximo 128 caracteres",
    })
  )(),
  "user.name": composeValidators(
    isRequired({ message: "El Nombre es obligatorio" }),
    matchesPattern(/^[A-zÀ-ÿ \-]*$/)({
      message:
        "Solo se permiten caracteres alfanuméricos",
    }),
    hasLengthLessThan(65)({
      message: "El Nombre debe tener máximo 64 caracteres",
    }),
    hasLengthGreaterThan(1)({
      message: "El Nombre debe tener al menos 2 caracteres",
    }),
  )(),
  "user.lastName": composeValidators(
    isRequired({ message: "El Apellido es obligatorio" }),
    matchesPattern(/^[A-zÀ-ÿ \-]*$/)({
      message:
        "Solo se permiten caracteres alfanumérico",
    }),
    hasLengthLessThan(65)({
      message: "El Apellido debe tener máximo 64 caracteres",
    }),
    hasLengthGreaterThan(1)({
      message: "El Apellido debe tener al menos 2 caracteres",
    }),
  )(),
  "user.phone": composeValidators(
    isRequired({ message: "El Teléfono es obligatorio" }),
    matchesPattern(/^[a-zA-Z0-9\.()-\\]*$/)({
      message:
        "Teléfono no válido. Contiene espacios o caracteres especiales diferente a: ( ) - . \\",
    }),
    hasLengthGreaterThan(6)({
      message: "El Teléfono debe tener al menos 7 caracteres",
    }),
    hasLengthLessThan(33)({
      message: "El Teléfono debe tener máximo 32 caracteres",
    })
  )(),
  "user.email": composeValidators(
    isRequired({ message: "El Email es obligatorio" }),
    matchesPattern(/^([\w\.\-]+)@([\w\-]+)((\.(\w){2,3})+)$/)({
      message: "Por favor digite un Email valido",
    }),
    hasLengthLessThan(257)({
      message: "El Email debe tener máximo 256 caracteres",
    }),
    hasLengthGreaterThan(5)({
      message: "El Email debe tener al menos 6 caracteres",
    }),
  )(),
});

const NewUserClientForm = () => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { newUserClient, checkUsername } = rootStore.clienStore;
  const { loading } = rootStore.buttonLoadingStore;

  const [userCheck, setCheck] = useState(false);

  const [createUserForm] = useState<IUserAdmin>({
    user: {
      name: "",
      lastName: "",
      phone: "",
      email: "",
      username: "",
    },
  });

  const handleFinalFormSubmit = (values: any) => {
    if (!userCheck) {
      values.user.name = values.user.name.trim();
      values.user.lastName = values.user.lastName.trim();
      values.user.email = values.user.email.trim();
      values.user.phone = values.user.phone.trim();
      values.user.username = values.user.username.trim();
      newUserClient(values);
    }
  };

  const handleblur = async (value: any) => {
    if (value !== "") setCheck(await checkUsername(value));
  };

  return (
    <div className="modalContent">
      <FinalForm
        validate={validate}
        initialValues={createUserForm}
        onSubmit={handleFinalFormSubmit}
        render={({ handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <Container textAlign="justified">
              <label>Usuario de acceso</label>
              <Field name="user.username" value={createUserForm.user.username}>
                {(props) => (
                  <Form.Field error={props.meta.touched && !!props.meta.error}>
                    <input
                      {...props.input}
                      onBlur={() => handleblur(props.input.value)}
                      onKeyUp={()=>setCheck(false)}
                    />
                    {props.meta.touched && props.meta.error && (
                      <Label basic color="red">
                        {props.meta.error}
                      </Label>
                    )}
                    {userCheck && (
                      <Label basic color="red">
                        Usuario de acceso ya existe
                      </Label>
                    )}
                  </Form.Field>
                )}
              </Field>
              <label>Nombres</label>
              <Field
                name="user.name"
                value={createUserForm.user.name}
                component={TextInput}
              />
              <label>Apellidos</label>
              <Field
                name="user.lastName"
                value={createUserForm.user.lastName}
                component={TextInput}
              />
              <label>Teléfono</label>
              <Field
                name="user.phone"
                value={createUserForm.user.phone}
                component={TextInput}
              />
              <label>Mail notificaciones</label>
              <Field
                name="user.email"
                value={createUserForm.user.email}
                component={TextInput}
              />
              <div className="adminCheck">
                <label>Administrador</label>
                <Field
                  name="isAdministrator"
                  component="input"
                  type="checkbox"
                  initialValue={true}
                />
              </div>
              <br />
              <br />
              <Button
                loading={loading}
                disabled={loading}
                className="ui primary button"
                color="blue"
                type="submit"
                content="Guardar"
              />
            </Container>
          </Form>
        )}
      />
    </div>
  );
};

export default observer(NewUserClientForm);
